const fetchWithRetry = async (url, options, retries = 3) => {
  for (let i = 0; i < retries; i++) {
    try {
      const response = await fetch(url, options);
      
      if (!response.ok) {
        console.error(`HTTP error! status: ${response.status}, statusText: ${response.statusText}`);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      // Check if response has content and is JSON
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        const data = await response.json();
        return data;
      } else {
        // Handle non-JSON responses
        const text = await response.text();
        return text;
      }
    } catch (error) {
      console.error(`Attempt ${i + 1} failed:`, error.message);
      if (i === retries - 1) {
        console.error(`All ${retries} attempts failed for: ${url}`);
        throw error;
      }
      // Exponential backoff
      const delay = 1000 * Math.pow(2, i);
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
};

export const GET = async (url, options = {}, key = "") => {
  try {
    
    const fetchOptions = {
      method: 'GET',
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
        ...(key && { "x-api-key": key })
      },
    };
    
    const response = await fetchWithRetry(url, fetchOptions);
    return response;
  } catch (error) {
    console.error('GET request failed for URL:', url, 'Error:', error);
    throw error;
  }
};

export const POST = async (url, data = {}, options = {}, key = "") => {
  try {
    
    const fetchOptions = {
      method: "POST",
      body: JSON.stringify(data),
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
        ...(key && { "x-api-key": key })
      },
    };

    const response = await fetchWithRetry(url, fetchOptions);
    return response;
  } catch (error) {
    console.error('POST request failed for URL:', url, 'Error:', error);
    throw error;
  }
};
